/**
 * Naturals portal login entry points (neutral URL labels).
 *
 * UI audience     | Login path              | DB / JWT role
 * ----------------|-------------------------|---------------------------
 * executive       | /nyafaz-ep/executive     | super_admin
 * workspace       | /nyafaz-ep/workspace     | admin
 * partner         | /nyafaz-ep/partner       | user (outlet accounts)
 *
 * Kiosk device login uses a separate JWT role `franchise_flow` (not portal Partner).
 */

export const EXECUTIVE_LOGIN_PATH = "/nyafaz-ep/executive";
export const WORKSPACE_LOGIN_PATH = "/nyafaz-ep/workspace";
export const PARTNER_LOGIN_PATH = "/nyafaz-ep/partner";
export const ACTIVATE_BASE_PATH = "/nyafaz-ep/activate";

/** @deprecated aliases kept for imports */
export const SUPER_ADMIN_LOGIN_PATH = EXECUTIVE_LOGIN_PATH;
export const HQ_ADMIN_LOGIN_PATH = WORKSPACE_LOGIN_PATH;
export const FRANCHISE_LOGIN_PATH = PARTNER_LOGIN_PATH;

export function loginPathForRole(role) {
  const r = String(role || "").toLowerCase();
  if (r === "super_admin") return EXECUTIVE_LOGIN_PATH;
  if (r === "user" || r === "partner" || r === "franchise" || r === "franchise_admin") {
    return PARTNER_LOGIN_PATH;
  }
  return WORKSPACE_LOGIN_PATH;
}

export function loginPathForAudience(audience) {
  const a = String(audience || "admin").toLowerCase();
  if (a === "super_admin" || a === "super-admin" || a === "executive") return EXECUTIVE_LOGIN_PATH;
  // legacy: franchise / franchise_admin / user → Partner portal
  if (a === "partner" || a === "franchise" || a === "user" || a === "franchise_admin") {
    return PARTNER_LOGIN_PATH;
  }
  return WORKSPACE_LOGIN_PATH;
}

export function audienceLabel(audience) {
  const a = String(audience || "admin").toLowerCase();
  if (a === "super_admin" || a === "super-admin" || a === "executive") return "Executive";
  if (a === "partner" || a === "franchise" || a === "user" || a === "franchise_admin") {
    return "Partner";
  }
  return "Workspace";
}

export function setPasswordPath(token) {
  return `${ACTIVATE_BASE_PATH}/set-password/${token || ""}`;
}
